const SCHEDULES_PATH = '/content/'

export { SCHEDULES_PATH }
